import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { map } from 'lodash';
import classnames from 'classnames';
import { Icon } from 'modules/icon-bank';

import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { WIDGET_NAMES } from 'constants/entity-names';
import { getLabel } from 'utils/getLabel';
import { layoutConfig } from 'config/table-configs/call-list';

//widget view
import { ActionWidgetItemDetailSummary } from 'ui/containers/ActionWidgetItemDetailSummary';
import { ActionItemDetailInnerTab } from 'ui/containers/ActionItemDetailInnerTab';

const WIDGET_VIEWS = {
    [ WIDGET_NAMES.ACTION_DETAIL_SUMMARY ]: ActionWidgetItemDetailSummary,
    [ WIDGET_NAMES.ACTION_DETAIL_TABS ]: ActionItemDetailInnerTab,
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { actionWidgetItemDetail as ActionWidgetItemDetail } from 'ui/views/widgets/actionWidgetItemDetail';
 *
 * // render
 * <ActionWidgetItemDetail propName='propValue'/>
 */
export const actionWidgetItemDetail = ( props ) => {
    return (
        <div className='ui-action-widget-item-detail'>
              <div className='ui-action-widget-item-detail__action'>
                {
                    map( props.navActions, navAction => {

                        // get the action for navAction
                        const icondId = 'back' === navAction.name ? 'backArrow': null;

                        return (
                            <div className='ui-action-widget-item-detail__action__navaction' key={ navAction.name }
                                onClick={ () => props.onNavActionClick( { type: 'headerAction', value: navAction } ) }
                            >
                                <Icon id={ icondId } />
                                <div className='ui-action-widget-item-detail__action__navaction__label'>{ getLabel( navAction.title ) }</div>
                            </div>
                        );

                    } )
                }
            </div>

            <div className='ui-action-widget-item-detail'>
                {
                    map( props.widgets, ( widget, widgetIndex ) => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        const widgetClassName = classnames( 'ui-action-widget-item-detail__widget', `ui-action-widget-item-detail__widget--name-${ widget.name }` );
    
                        return (
                            <div key={ widgetIndex } className={ widgetClassName }>
                                <WidgetView
                                    widget={ widget }
                                    actionId={ props.actionId }
                                    requestPayload={ props.requestPayload }
                                    layoutConfig={ {...layoutConfig, dimension: { maxHeight: layoutConfig.maxHeight, padding: 10 }} }
                                />
                            </div>
                        );
                    } )
                }
                
            </div>

        </div>
    );
};

// set display name
actionWidgetItemDetail.displayName = 'actionWidgetItemDetail';

// set default props
actionWidgetItemDetail.defaultProps = {};

// prop types
actionWidgetItemDetail.propTypes = {};


// preloader view
export const actionWidgetItemDetailPreloader = () => {
    return (
        <div className='ui-action-widget-item-detail-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
actionWidgetItemDetailPreloader.displayName = 'actionWidgetItemDetailPreloader';

// set default props
actionWidgetItemDetailPreloader.defaultProps = {};

// prop types
actionWidgetItemDetailPreloader.propTypes = {};

export const actionWidgetItemDetailView = withNetworkState( actionWidgetItemDetailPreloader, actionWidgetItemDetail );
